import {AvatarPart, uid} from "../common";
import {fabricColors} from "../colors";

const id = {
	path1: uid("path-"),
	path2: uid("path-"),
};

export default new AvatarPart({
	defs: [
		`<path
			id="${id.path1}"
			d="M66,0 L66,0 C102.450793,-6.69590214e-15 132,29.5492065 132,66 L132,71 L0,71 L0,66 C-4.46393476e-15,29.5492065 29.5492065,6.69590214e-15 66,0 Z"
			/>`,
		`<path
			id="${id.path2}"
			d="M67.2846026,61.4514246 C83.229708,49.8171415 105.159178,44 133.073012,44 C160.985408,44 182.871592,49.8165424 198.731564,61.4496271 L198.731562,61.4496305 C200.786183,62.956669 202.000006,65.3523289 202.000006,67.900394 L202.000004,98.3697692 C202.000004,100.578907 200.209144,102.369768 198.000006,102.369768 C197.244444,102.369768 196.504332,102.155773 195.865355,101.752558 C179.223261,91.2508526 158.536251,86 133.804323,86 C108.883259,86 87.640395,91.3314713 70.0757313,101.994414 L70.0757317,101.994414 C68.1873241,103.140806 65.7271332,102.539283 64.5807417,100.650875 C64.2008775,100.02514 64.0000054,99.3071624 64.0000054,98.5751499 L64,67.914014 C64,65.358892 65.2205159,62.9574773 67.2846026,61.4514246 Z"
			/>`,
	],
	render ({color}) {
		return `
			<g>
				<g transform="translate(-1.000000, 0.000000)">
					<g stroke-width="1" fill-rule="evenodd" transform="translate(67.000000, 12.000000)">
						<circle fill="#F4F4F4" cx="66" cy="8" r="20"/>
						<use fill="${color}" xlink:href="#${id.path1}"/>
					</g>
					<g>
						<use fill="black" fill-opacity="1" filter="url(#${id.path2})" xlink:href="#${id.path2}"/>
						<use fill="#F4F4F4" fill-rule="evenodd" xlink:href="#${id.path2}"/>
					</g>
				</g>
			</g>
		`;
	},
	attrs: {
		color: fabricColors,
	},
});



// WEBPACK FOOTER //
// ./src/top/winter-hat-3.js